<template>
   <bindBankCard/>
</template>

<script>
import bindBankCard from './bindBankCard.vue'

export default {
  name: 'bindBankCardContainer',
  components: {
    bindBankCard,
  },
}

</script>
